var phoneLogoImage = "/static/7f5e9d9fd5a61316.svg";

export { phoneLogoImage as default };
//# sourceMappingURL=phone_logo_2.svg.js.map
